import React from "react";
import { ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import { MessageUtilities } from "../../../Utilities";
import styles from "./styles.module.css";

export type ControlledMessageAlertIconProps = {
	messagingPagePath: string;
} & Omit<MessageAlertIconProps, "count">;

export function ControlledMessageAlertIcon({ messagingPagePath, ...props }: ControlledMessageAlertIconProps) {
	const { showUnreadMessagesAlert, numUnreadMessages } = MessageUtilities.useUnreadMessagesAlert({
		messagingPagePath,
	});

	if (!showUnreadMessagesAlert) {
		return null;
	}

	return <MessageAlertIcon count={numUnreadMessages} {...props} />;
}

export type MessageAlertIconProps = {
	count: number | null | undefined;
	maxCount?: number;
	size?: string;
} & Partial<ClassNameProps & StyleProps>;

export function MessageAlertIcon({ count, maxCount = 99, size, className, style }: MessageAlertIconProps) {
	const definedCount = count ?? 0;
	const countDisplay = definedCount > maxCount ? `${maxCount}+` : definedCount.toString();

	const textLength = countDisplay.toString().length;
	const textScale = textLength === 1 ? 1 / 2.25 : 1 / (textLength + 1);

	return (
		<div
			className={makeClassName(styles["alert-icon"], className)}
			style={{ "--alert-icon---size": size, ...style } as React.CSSProperties}
		>
			<span
				className={styles["alert-icon__text"]}
				style={{ "--alert-icon__text---scale": textScale } as React.CSSProperties}
			>
				{countDisplay}
			</span>
		</div>
	);
}
